import { render, staticRenderFns } from "./form-component-overview-selection.vue?vue&type=template&id=aaad2268"
import script from "./form-component-overview-selection.vue?vue&type=script&lang=ts"
export * from "./form-component-overview-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports